const NAG_GROUP_MAP = {
    "Move Quality": {
        "!": "Good move",
        "?": "Mistake",
        "!!": "Brilliant move",
        "??": "Blunder",
        "!?": "Interesting move",
        "?!": "Dubious move",
        "⭘": "Only move",
        "□": "Zugzwang",
    },
    "Position Evaluation": {
        "=": "Equal position",
        "∞": "Unclear position",
        "+/=": "Slight advantage for White",
        "=/+": "Slight advantage for Black",
        "+/-": "Moderate advantage for White",
        "-/+": "Moderate advantage for Black",
        "+-": "Decisive advantage for White",
        "-+": "Decisive advantage for Black",
    },
    "Strategic Elements": {
        "⟳": "With initiative",
        "↑": "With attack",
        "→": "With counterplay",
        "⇆": "With the idea of",
        "⨀": "Development advantage",
        "⊕": "Space advantage",
        "⊖": "Better pawn structure",
        "⊙": "Bishop pair advantage",
        "⊡": "Time trouble",
    },
    Other: {
        N: "Novelty",
        D: "Dubious novelty",
        Z: "Zugzwang",
        T: "Time control pressure",
    },
};
const COMMON_NAGS = ["!", "?", "!!", "??", "!?", "?!"];
const NAG_GROUPS = Object.entries(NAG_GROUP_MAP).reduce((acc, [group, nags]) => ({
    ...acc,
    [group]: Object.keys(nags),
}), {});
const NAG_VALUES = Object.values(NAG_GROUPS).flat();
const NAG_MAP = Object.values(NAG_GROUP_MAP).reduce((acc, groupNags) => {
    Object.keys(groupNags).forEach((nag) => {
        acc[nag] = groupNags[nag];
    });
    return acc;
}, {});
export { NAG_GROUP_MAP, COMMON_NAGS, NAG_GROUPS, NAG_VALUES, NAG_MAP };
